import React from 'react'
import styled from 'styled-components'

const ContainerIcon = styled.div`
    background: transparent;
    border: 1px solid ${p => p.theme.palette.primary.main};
    width: 35px;
    height: 35px;
    border-radius: 50%;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: .3s;
    cursor: pointer;
    
    > svg {
        color: ${p => p.theme.palette.primary.main};
    }

    :hover{
      background: ${p => p.theme.palette.primary.main};
      
      > svg {
        color: white;
      }
    }
`

interface IOwnProps{
    icon: React.ReactElement
}

const SocialItem: React.FunctionComponent<IOwnProps> = ({ icon }) => {
  return (
    <ContainerIcon>
        {icon}
    </ContainerIcon>
  )
}

export default SocialItem